import React, { useCallback, useMemo, useRef, useState } from 'react';

import { IonPage } from '@ionic/react';

import { useStorage } from 'components/Storage';

import { ScreenProvider } from './ScreenContext';
import { IAction } from './consts';

export const withScreen =
  ({ screenReducer, initialState, name }: any) =>
  (BaseComponent: React.FC) =>
  () => {
    const [restoredState, setRestoredState] = useState<any>(null);
    const storage: any = useStorage();
    const navRef: any = useRef();

    useMemo(() => {
      storage.get(name).then((res: any) => {
        setRestoredState(res || initialState);
      });
    }, [storage]);

    const screenReducerWrapper = useCallback(
      (state = {}, action: IAction) => {
        const result = screenReducer(state, action);
        storage.set(name, result);

        return result;
      },
      [name, storage, screenReducer]
    );

    if (!restoredState) {
      return null;
    }

    return (
      <ScreenProvider
        screenReducer={screenReducerWrapper}
        initialState={restoredState}
        nav={navRef.current}
      >
        <IonPage className={`${name}-page`}>
          <BaseComponent />
        </IonPage>
      </ScreenProvider>
    );
  };
